document.addEventListener('DOMContentLoaded', function() {
    // Initialize Fancybox for each image grid section
    Fancybox.bind('[data-fancybox]', {
        Hash: false,
        Thumbs: false,

        compact: false,

        contentClick: "toggleCover",
        wheel : "slide",

        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["close"],
            },
        },

        Images: {
            Panzoom: {
                panMode: "mousemove",
                mouseMoveFactor: 1.1,
                mouseMoveFriction: 0.12
            },
        },
    });
});

